module.exports = __webpack_public_path__ + "static/media/node-node-js-seeklogo.com.89ccb090.svg";